import {Core} from "../../../Base/Core";

//----------------------------------------------------------------------------------------------------------------------

const _MISSING_TEXTURES = new Set();
window._MISSING_TEXTURES = _MISSING_TEXTURES;

export function findTexture(texture) {
    if (texture && typeof texture === "string") {
        if (!PIXI.utils.TextureCache[texture]) {
            if (!_MISSING_TEXTURES.has(texture)) {
                console.warn(`TEXTURE not in cache: ${texture}`);
            }
            _MISSING_TEXTURES.add(texture);
        }
        texture = PIXI.utils.TextureCache[texture];
    }
    return texture || PIXI.Texture.EMPTY;
}

//----------------------------------------------------------------------------------------------------------------------

PIXI.DisplayObject.prototype.Init = function () {};
PIXI.DisplayObject.prototype.Awake = function () {};
PIXI.DisplayObject.prototype.Start = function () {};
PIXI.DisplayObject.prototype.Update = function () {};
PIXI.DisplayObject.prototype.OnEnable = function () {};
PIXI.DisplayObject.prototype.OnDisable = function () {};
PIXI.DisplayObject.prototype.OnDestroy = function () {};
PIXI.DisplayObject.prototype.Show = function () {
    this.visible = true;
    if (!this.Active) {
        this.Active = true;
        this.emit("Show");
        this.emit("ActiveChanged", this.Active);
    }
};
PIXI.DisplayObject.prototype.Hide = function () {
    this.visible = false;
    if (this.Active) {
        this.Active = false;
        this.emit("Hide");
        this.emit("ActiveChanged", this.Active);
    }
};
PIXI.DisplayObject.prototype.SetActive = function (active) {
    if (active) this.Show();
    else this.Hide();
};
PIXI.DisplayObject.prototype.fitLayout = function (viewport = (Core.app && Core.app.viewport) || new PIXI.Rectangle(0, 0, 1, 1)) {};

PIXI.Container.prototype._debug = function (container = this, clear = false) {
    this._g = this._g || container.addChild(new PIXI.Graphics);
    if (clear) this._g.clear();
    return this._g;
};
PIXI.Container.prototype._debugRect = function (rect, color = 0xFF0000) {
    this._debug().lineStyle(1, color).drawRect(rect.x, rect.y, rect.width, rect.height);
};

PIXI.Container.prototype._clearTapHighlight = function() {
    this.off("pointerdown", this._setTapHighlight);
    this.off("pointerup", this._removeTapHighlight);
    this.off("pointerupoutside", this._removeTapHighlight);
    this.off("pointerleave", this._removeTapHighlight);
    this.off("pointerout", this._removeTapHighlight);
    this.off("pointercancel", this._removeTapHighlight);
    this.tapHighlightTarget = null;
};
PIXI.Container.prototype._initTapHighlight = function(highlightTarget = this.tapHighlightTarget || this) {
    this._clearTapHighlight();
    if (highlightTarget) {
        this.on("pointerdown", this._setTapHighlight, this);
        this.on("pointerup", this._removeTapHighlight, this);
        this.on("pointerupoutside", this._removeTapHighlight, this);
        this.on("pointerleave", this._removeTapHighlight, this);
        this.on("pointerout", this._removeTapHighlight, this);
        this.on("pointercancel", this._removeTapHighlight, this);
        this.tapHighlightTarget = highlightTarget;
    }
};
PIXI.Container.prototype._setTapHighlight = function() {
    if (this.tapHighlightTarget) {
        this._tapHighlightPrevTint = this.tapHighlightTarget.tint;
        this.tapHighlightTarget.tint = 0x999999;
    }
};
PIXI.Container.prototype._removeTapHighlight = function() {
    if (this.tapHighlightTarget) {
        this.tapHighlightTarget.tint = this._tapHighlightPrevTint !== undefined ? this._tapHighlightPrevTint : 0xFFFFFF;
    }
};



Object.defineProperty(PIXI.DisplayObject.prototype, "activeInHierarchy", {
    get: function () {
        let obj = this;
        if (obj.visible) return true;
        while (obj.parent) {
            if (!obj.parent.visible) return false;
            obj = obj.parent;
        }
        return true;
    },
});

//----------------------------------------------------------------------------------------------------------------------

const SYSTEM_FONT = "-apple-system,BlinkMacSystemFont,Roboto,Helvetica,Arial,sans-serif";
/**
 * Регулярное выражение для проверки символов в тексте при активном adjustFontFamily
 * @default /^[\u0000-\u007f]+$/
 */
const ADJUST_FONT_FAMILY_REGEXP = /^[\u0000-\u007f]+$/;

export class ExtText extends PIXI.Text {
    constructor(...args) {
        super(...args);
        this.style.baseFontSize = this.style.fontSize;
        this.style.baseFontFamily = this.style.fontFamily;
        this.extendStyleProps();
        this.chooseFontFamily();
    }

    extendStyleProps() {
        this.style._autoFit = !!this.style.autoFit;
        this.style._fitTextTemplate = this.style.fitTextTemplate || "";
        this.style._autoFitPadding = this.style.autoFitPadding || 0;
        this.style._autoFitWidth = this.style.autoFitWidth || 0;
        this.style._autoFitHeight = this.style.autoFitHeight || 0;
        this.style._adjustFontFamily = !!this.style.adjustFontFamily;
        this.style._adjustFontFamilyRegExp = this.style.adjustFontFamilyRegExp instanceof RegExp
            ? this.style.adjustFontFamilyRegExp
            : undefined
        ;
        Object.defineProperty(this.style, "autoFit", {
            get: function () {
                return this._autoFit;
            },
            set: function (val) {
                val = !!val;
                if (this._autoFit !== val) {
                    this._autoFit = val;
                    this.styleID++;
                }
            },
        });
        Object.defineProperty(this.style, "fitTextTemplate", {
            get: function () {
                return this._fitTextTemplate;
            },
            set: function (val) {
                val = val || "";
                if (this._fitTextTemplate !== val) {
                    this._fitTextTemplate = val;
                    this.styleID++;
                }
            },
        });
        Object.defineProperty(this.style, "autoFitPadding", {
            get: function () {
                return this._autoFitPadding;
            },
            set: function (val) {
                val = parseFloat(val);
                if (isNaN(val)) val = 0;
                if (this._autoFitPadding !== val) {
                    this._autoFitPadding = val;
                    this.styleID++;
                }
            },
        });
        Object.defineProperty(this.style, "fontSize", {
            get: function () {
                return this._fontSize;
            },
            set: function (val) {
                val = parseFloat(val);
                if (isNaN(val)) val = 0;
                if (this._fontSize !== val) {
                    this.baseFontSize = Math.max(val, this.baseFontSize);
                    this._fontSize = val;
                    this.styleID++;
                }
            },
        });
        Object.defineProperty(this.style, "autoFitWidth", {
            get: function () {
                return this._autoFitWidth;
            },
            set: function (val) {
                val = parseFloat(val);
                if (isNaN(val)) val = 0;
                if (this._autoFitWidth !== val) {
                    this._autoFitWidth = val;
                    this.styleID++;
                }
            },
        });
        Object.defineProperty(this.style, "autoFitHeight", {
            get: function () {
                return this._autoFitHeight;
            },
            set: function (val) {
                val = parseFloat(val);
                if (isNaN(val)) val = 0;
                if (this._autoFitHeight !== val) {
                    this._autoFitHeight = val;
                    this.styleID++;
                }
            },
        });
        Object.defineProperty(this.style, "fontFamily", {
            get: function () {
                return this._fontFamily;
            },
            set: function (fontFamily) {
                if (this.fontFamily !== fontFamily) {
                    this.baseFontFamily = fontFamily;
                    this._fontFamily = fontFamily;
                    this.styleID++;
                }
            },
        });
        Object.defineProperty(this.style, "adjustFontFamily", {
            get: function () {
                return this._adjustFontFamily;
            },
            set: function (val) {
                val = !!val;
                if (this._adjustFontFamily !== val) {
                    this._adjustFontFamily = val;
                    this.styleID++;
                }
            },
        });
        Object.defineProperty(this, "text", {
            get: function () {
                return this._text;
            },
            set: function (text) {
                text = String(text === "" || text === null || text === undefined ? " " : text);
                if (this._text === text) {
                    return;
                }
                this._text = text;
                this.dirty = true;
                this.chooseFontFamily();
            },
        });
        Object.defineProperty(this.style, "adjustFontFamilyRegExp", {
            get: function () {
                return this._adjustFontFamilyRegExp;
            },
            set: function (regEx) {
                if (regEx instanceof RegExp) {
                    if (this._adjustFontFamilyRegExp !== regEx) {
                        this._adjustFontFamilyRegExp = regEx;
                        this.styleID++;
                    }
                } else {
                    console.warn("adjustFontFamilyRegExp is not an instance of RegExp");
                }
            },
        });
    }

    chooseFontFamily() {
        let selected = null;
        let testReg = null;
        if (this.style.adjustFontFamily) {
            testReg = ADJUST_FONT_FAMILY_REGEXP;
            if (this.style.adjustFontFamilyRegExp) testReg = this.style.adjustFontFamilyRegExp;
            if (!testReg.test(this.text)) {
                selected = SYSTEM_FONT;
            } else {
                selected = this.style.baseFontFamily;
            }
        } else {
            selected = this.style.baseFontFamily;
        }
        if (selected !== this.style.fontFamily) {
            this.style._fontFamily = selected;
            this.style.styleID++;
        }
    }

    fitText({ width = this.style.autoFitWidth, height = this.style.autoFitHeight } = {}) {
        let pad2 = (this.style.autoFitPadding || 0) * 2;
        width = Math.max(1, width - pad2);
        height = Math.max(1, height - pad2);
        if (width < 2 || height < 2) {
            this.style.fontSize = this.style.baseFontSize;
            return;
        }

        let { baseFontSize } = this.style;

        let style = this.style.clone();
        style.fontSize = baseFontSize;
        let measureText = this.style.fitTextTemplate || this.text;
        while (style.fontSize > 1) {
            let textMetrics = PIXI.TextMetrics.measureText(measureText, style);
            if (textMetrics.width <= width && textMetrics.height <= height) break;
            style.fontSize--;
        }

        // let checksCount = baseFontSize - style.fontSize;
        // if (checksCount > 20) {
        //     console.warn("ExtText. Potentially suboptimal use: the number of fit attempts exceeds 20. Current: " + checksCount);
        //     console.warn("Base font size: " + baseFontSize);
        //     console.warn("Selected font size: " + style.fontSize);
        //     console.warn(this.text);
        // }
        this.style.fontSize = style.fontSize;
    }

    updateText(respectDirty) {
        if (this.localStyleID !== this._style.styleID || this.dirty || !respectDirty) {
            if (this.style.autoFit && this.parent) {
                this.fitText();
            } else {
                this.style.fontSize = this.style.baseFontSize;
            }
            this.chooseFontFamily();
        }
        super.updateText(respectDirty);
    }
}
